import { SVGAttributes } from 'react';

export function SubnetIcon(props: SVGAttributes<SVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      version="1.1"
      width="151px"
      height="89px"
      viewBox="-0.5 -0.5 151 89"
      {...props}
    >
      <g>
        <g data-cell-id="0">
          <g data-cell-id="1">
            <g data-cell-id="43s24t3kMvA4kIPissoO-1" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-3" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-4" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-5" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-7" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-8" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-12" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-13" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-14" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-15" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-16" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-17" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-18" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-19" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-20" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-21" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-22" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-29">
              <g data-cell-id="43s24t3kMvA4kIPissoO-6" />
              <g data-cell-id="43s24t3kMvA4kIPissoO-27" />
              <g data-cell-id="43s24t3kMvA4kIPissoO-9" />
              <g data-cell-id="43s24t3kMvA4kIPissoO-28" />
            </g>
            <g data-cell-id="43s24t3kMvA4kIPissoO-25" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-33" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-36">
              <g>
                <ellipse
                  cx="46"
                  cy="45.28"
                  rx="10"
                  ry="10"
                  fill="currentColor"
                  stroke="none"
                  pointerEvents="all"
                />
              </g>
            </g>
            <g data-cell-id="43s24t3kMvA4kIPissoO-37">
              <g>
                <ellipse
                  cx="76"
                  cy="45.28"
                  rx="10"
                  ry="10"
                  fill="currentColor"
                  stroke="none"
                  pointerEvents="all"
                />
              </g>
            </g>
            <g data-cell-id="43s24t3kMvA4kIPissoO-38">
              <g>
                <ellipse
                  cx="106"
                  cy="45.28"
                  rx="10"
                  ry="10"
                  fill="currentColor"
                  stroke="none"
                  pointerEvents="all"
                />
              </g>
            </g>
            <g data-cell-id="43s24t3kMvA4kIPissoO-44">
              <g />
              <g data-cell-id="43s24t3kMvA4kIPissoO-42">
                <g>
                  <path
                    d="M 106 81.95 L 143.95 44"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="6"
                    strokeMiterlimit="10"
                    pointerEvents="stroke"
                  />
                </g>
              </g>
              <g data-cell-id="43s24t3kMvA4kIPissoO-43">
                <g>
                  <path
                    d="M 106.71 81.24 L 143.24 44.71"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="4"
                    strokeMiterlimit="10"
                    pointerEvents="stroke"
                  />
                  <ellipse
                    cx="106"
                    cy="81.95"
                    rx="1"
                    ry="1"
                    fill="currentColor"
                    stroke="currentColor"
                    strokeWidth="4"
                    pointerEvents="all"
                  />
                  <ellipse
                    cx="143.95"
                    cy="44"
                    rx="1"
                    ry="1"
                    fill="currentColor"
                    stroke="currentColor"
                    strokeWidth="4"
                    pointerEvents="all"
                  />
                </g>
              </g>
            </g>
            <g data-cell-id="43s24t3kMvA4kIPissoO-47">
              <g />
              <g data-cell-id="43s24t3kMvA4kIPissoO-45">
                <g>
                  <path
                    d="M 106 6 L 144 44"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="6"
                    strokeMiterlimit="10"
                    pointerEvents="stroke"
                  />
                </g>
              </g>
              <g data-cell-id="43s24t3kMvA4kIPissoO-46">
                <g>
                  <path
                    d="M 106.71 6.71 L 143.29 43.29"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="4"
                    strokeMiterlimit="10"
                    pointerEvents="stroke"
                  />
                  <ellipse
                    cx="106"
                    cy="6"
                    rx="1"
                    ry="1"
                    fill="currentColor"
                    stroke="currentColor"
                    strokeWidth="4"
                    pointerEvents="all"
                  />
                  <ellipse
                    cx="144"
                    cy="44"
                    rx="1"
                    ry="1"
                    fill="currentColor"
                    stroke="currentColor"
                    strokeWidth="4"
                    pointerEvents="all"
                  />
                </g>
              </g>
            </g>
            <g data-cell-id="43s24t3kMvA4kIPissoO-48">
              <g />
              <g data-cell-id="43s24t3kMvA4kIPissoO-39">
                <g>
                  <path
                    d="M 6 43.95 L 43.95 6"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="6"
                    strokeMiterlimit="10"
                    pointerEvents="stroke"
                  />
                </g>
              </g>
              <g data-cell-id="43s24t3kMvA4kIPissoO-41">
                <g>
                  <path
                    d="M 6.71 43.24 L 43.24 6.71"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="4"
                    strokeMiterlimit="10"
                    pointerEvents="stroke"
                  />
                  <ellipse
                    cx="6"
                    cy="43.95"
                    rx="1"
                    ry="1"
                    fill="currentColor"
                    stroke="currentColor"
                    strokeWidth="4"
                    pointerEvents="all"
                  />
                  <ellipse
                    cx="43.95"
                    cy="6"
                    rx="1"
                    ry="1"
                    fill="currentColor"
                    stroke="currentColor"
                    strokeWidth="4"
                    pointerEvents="all"
                  />
                </g>
              </g>
            </g>
            <g data-cell-id="43s24t3kMvA4kIPissoO-49">
              <g />
              <g data-cell-id="43s24t3kMvA4kIPissoO-50">
                <g>
                  <path
                    d="M 6 44 L 44 82"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="6"
                    strokeMiterlimit="10"
                    pointerEvents="stroke"
                  />
                </g>
              </g>
              <g data-cell-id="43s24t3kMvA4kIPissoO-51">
                <g>
                  <path
                    d="M 6.71 44.71 L 43.29 81.29"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="4"
                    strokeMiterlimit="10"
                    pointerEvents="stroke"
                  />
                  <ellipse
                    cx="6"
                    cy="44"
                    rx="1"
                    ry="1"
                    fill="currentColor"
                    stroke="currentColor"
                    strokeWidth="4"
                    pointerEvents="all"
                  />
                  <ellipse
                    cx="44"
                    cy="82"
                    rx="1"
                    ry="1"
                    fill="currentColor"
                    stroke="currentColor"
                    strokeWidth="4"
                    pointerEvents="all"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
